<template>
  <b-modal
    id="edit-country-modal"
    centered
    size="lg"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    dialog-class="my-dialog-class"
  >
    <template #modal-title> <h2 class="m-0">Edit Country</h2> </template>
    <validation-observer ref="editCountryFormValidation">
      <b-form @submit.prevent>
        <b-form-row>
          <b-col md="6">
            <b-form-group label-for="name">
              <template #label>
                Name <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Name"
                :rules="{ required }"
              >
                <b-form-input
                  id="name"
                  v-model="name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="code">
              <template #label>
                Code <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Code"
                :rules="{ required }"
              >
                <b-form-input
                  id="code"
                  v-model="code"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Code"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col md="6">
            <div class="d-flex">
              <b-form-group label-for="image" class="mr-1">
                <template #label>
                  Image <span class="text-danger">*</span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Image"
                  rules="required"
                >
                  <b-form-file
                    id="image"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    v-model="file"
                    :accept="acceptedFiles.join(', ')"
                  />
                  <small class="text-danger" v-if="documentError === 1">
                    Supported File Types are {{ acceptedFiles.join(", ") }}
                  </small>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
              <div class="d-flex align-items-center">
                <b-button
                  variant="outline-primary"
                  @click="() => openFile(country.image)"
                >
                  <feather-icon icon="EyeIcon" size="16" />
                </b-button>
              </div>
            </div>
          </b-col>
        </b-form-row>
      </b-form>
    </validation-observer>
    <template #modal-footer>
      <b-form-group class="text-right">
        <b-button type="submit" variant="info" pill @click="validationForm">
          Update
        </b-button>
      </b-form-group>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import { required } from "@validations";
import util from "@/util.js";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    VueSelectPaginated,
  },
  props: {
    country: Object,
  },
  mixins: [util],
  data() {
    return {
      required,
      name: "",
      code: "",
      file: null,
      documentType: null,
      documentError: 0,
      acceptedFiles: [".jpg", ".jpeg", ".png"],
    };
  },
  async mounted() {
    if (this.country) {
      this.name = this.country.name;
      this.code = this.country.code;
    }
  },
  methods: {
    ...mapActions({
      updateCountry: "appData/updateCountry",
      getRoles: "appData/getRoles",
    }),
    async validationForm() {
      const success = await this.$refs.editCountryFormValidation.validate();
      if (success) {
        await this.submit();
      }
    },
    async submit() {
      try {
        const formData = new FormData();

        const data = {
          name: this.name,
          code: this.code,
          created_by: this.getLoggedInUser.id,
          updated_by: this.getLoggedInUser.id,
        };

        formData.append("image", this.file);
        formData.append("data", JSON.stringify(data));

        const res = await this.updateCountry({
          payload: formData,
          pk: this.country.id,
        });
        if (res.status === 200) {
          this.$swal({
            title: "Country updated successfully",
            icon: "success",
          });
          this.$nextTick(() => {
            this.$bvModal.hide("edit-country-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
};
</script>

<style></style>
